import { Component, Optional, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MatSnackBar } from '@angular/material';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/interval';
import 'rxjs/add/observable/fromEvent';

// import { BlobService, UploadConfig, UploadParams } from 'angular-azure-blob-service';
// import { Adal6Service } from 'adal-angular6';
// import { adal } from 'adal-angular6';
import { FileUploader } from 'ng2-file-upload';
import { environment } from '../environments/environment';

// import { DialogContentComponent } from './dialog-content.component';
import { AndonUser } from './andon-user';
import { AndonGroup } from './andon-group';
import { AndonNotice, OutputAndonNoticeID, AndonNoticeSum } from './andon-notice';
import { AndonCauseCode } from './andon-cause-code';
import { AndonUserService } from './andon-user.service';
import { AndonGroupService } from './andon-group.service';
import { AndonNoticeService } from './andon-notice.service';
import { AndonCauseCodeService } from './andon-cause-code.service';
// import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

/*
const Config: UploadParams = {
  sas: environment.sas,
  storageAccount: environment.storageAccount,
  containerName: environment.containerName
};
*/
// const adalConfig: adalConfig = {
/*
const adalConfig = {
  tenant: 'kispfsol.onmicrosoft.com',
  clientId: '3c506460-592d-4e00-bda4-9e8ba2ebedec'
};
*/

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {

  // インターバル(再表示用)
  private timer: Subscription;

  // 英語化
  NameMst: any[] = [
    { headertitle: 'Andon', input: 'Input', registration: 'New Registration', refresh: 'Refresh',
      restoration: 'State restoration', remove: 'Remove notification', title: 'Title',
      reasoncode: 'Reason code', sender: 'Sender', andoncolor: 'Andon Color', message: 'Message',
      apierror: 'I can not connect to the server.', loginerror: 'User or password is invalid.',
      continure: 'Do you want to continue?', anotherlang: 'Japanese' },
    { headertitle: '業務あんどん', input: '新規入力', registration: '新規登録', refresh: '再検索',
      restoration: '状態復帰', remove: '通知削除', title: 'タイトル',
      reasoncode: '理由コード', sender: '送信者', andoncolor: 'あんどん色', message: 'メッセージ',
      apierror: 'サーバに接続出来ません', loginerror: 'ユーザまたはパスワードが違います',
      continure: '続行しますか？', anotherlang: 'English' }
  ];

  LangId = 1;
  timeDifference = 9;

  isDarkTheme = false;

 // adalUsername = '';

  UserID = '';
  UserPasswd = '';
  UserName = '';
  InputUserID = '';
  InputPasswd = '';
  AndonGroupID = 0;
  AndonGroupName = '';
  CauseCodeIndex = 0;

  baseImageUrl = '';
  // baseImageSas = '';
  imageUrl = '';
  AndonID = 0;
  AndonName = '';
  AndonNoticeID = 0;
  AndonNoticeIndex = 0;
  lastDialogResult = 0;
  lastDialogAction = 0;
  AttachementFile = '';
  SelectedFile: any;

  Title = '';
  AndonColor = '';
  Message = '';
  Display = 0;
  LoginErrMsg = '';

  selectedValue: string;
  progress = 0;

  set tickInterval(v) {
    this.tickInterval = Number(v);
  }

  // now: Date;
  andonUser: AndonUser = new AndonUser;
  andonUsers: AndonUser[];
  andonGroup: AndonGroup[];
  andonNoticeList: AndonNotice[];
  andonNoticeSum: AndonNoticeSum[];
  andonCauseCode: AndonCauseCode[];
  andonNoticeNew: AndonNotice = new AndonNotice;
  andonNoticeSel: AndonNotice[];
  outputAndonNoticeID: OutputAndonNoticeID = new OutputAndonNoticeID;

  /** The upload config */
  // config: UploadConfig = null;
  /** The selected file */
  // currentFile: File = null;
  /** The current percent to be displayed */
  percent: Number = 0;

  // uploader: FileUploader;
  // response: string;
  public uploader: FileUploader = new FileUploader(
     {url: environment.apiUrl + 'AndonNotice/UploadFiles'}
  );

  // コンストラクターは、そのクラスのオブジェクトが作成されるたびに呼び出される
  constructor (

    private http: HttpClient,
    // private service: Adal6Service,
    // private blob: BlobService,
    private _dialog: MatDialog,
    private _snackbar: MatSnackBar,
    private andonUserService: AndonUserService,
    private andonGroupService: AndonGroupService,
    private andonCauseCodeService: AndonCauseCodeService,
    private andonNoticeService: AndonNoticeService
    ) {
      // this.service.init(adalConfig);
      /*
      this.uploader = new FileUploader({
        url: 'http://localhost:3000/api/upload',
        disableMultipart: false, // 'DisableMultipart' must be 'true' for formatDataFunction to be called.
        formatDataFunctionIsAsync: true,
        formatDataFunction: async (item) => {
          return new Promise( (resolve, reject) => {
            resolve({
              name: item._file.name,
              length: item._file.size,
              contentType: item._file.type,
              date: new Date()
            });
          });
        }
      });
      this.response = '';
      this.uploader.response.subscribe( res => this.response = res );
      */
    }

  // ngOnInitは、コンポーネントが作成されると呼び出される
  ngOnInit() {

    // インターバルを10Sに設定
    this.timer = Observable.interval(environment.interval)
              .subscribe(() => this.refresh() );
/*
    this.service.handleWindowCallback();
    if (!this.service.userInfo.authenticated) {
      this.service.login();
    }
    this.adalUsername = this.service.userInfo.username;
    console.log('profile', this.service.userInfo.profile);
*/
    /* Azure Storageの場合
    this.baseImageUrl = this.blob.generateBlobUrl(Config, '');
    this.baseImageSas = Config.sas;
    */
    this.baseImageUrl = environment.photoUrl;
    this.timeDifference = environment.timeDifference;
  }

  /*
  public logout() {
    this.service.logOut();
  }
  */

  // ユーザ認証
  public authUser(): void {
    this.UserName = '';
    this.Display = 1;
    this.UserID = this.InputUserID;
    this.AndonGroupID = 0;
    this.AndonGroupName = '#ALL';
    this.getAndonGroup();
    this.getAndonNoticeSum();
  }

  // あんどんのユーザを検索する
  public getAndonUsers(): void {
    //    this.http.get(this.AndonGroupUrl).toPromise();
    this.andonUserService.errMessage = this.NameMst[this.LangId].apierror;
    this.andonUserService.getAndonUsers()
      .subscribe(andonUsers => this.andonUsers = andonUsers);
  }

  // 指定したあんどんユーザの情報を取得する
  public getAndonUser(): void {

    // this.openSnackbar( 'TEST' );

    this.andonUserService.getAndonUser(this.InputUserID, this.InputPasswd)
      .subscribe(
        andonUser => {
            console.log('getAndonUser() test');
            if ( andonUser  ) {
              // this.andonUsers = andonUser;
              // this.andonUser = andonUser[0];
              // this.UserName = this.andonUser.userName;
              console.log(andonUser);
              this.Display = 1;
              this.UserID = this.InputUserID;
              this.AndonGroupID = 0;
              this.AndonGroupName = '#ALL';
              this.getAndonGroup();
              this.getAndonNoticeSum();
              this.LoginErrMsg = '';
              this.InputPasswd = '';
              //
              // this.UserName = andonUser[0].userName;
          } else {
            this.LoginErrMsg = this.NameMst[this.LangId].loginerror;
          }
          },
          error => {
            alert(this.NameMst[this.LangId].apierror);
            // this.openSnackbar('通信できません');
          });
  }
// あんどんグループを取得する
  public getAndonGroup(): void {
//    this.http.get(this.AndonGroupUrl).toPromise();
    this.andonNoticeService.errMessage = this.NameMst[this.LangId].apierror;
    this.andonGroupService.getAndonGroup()
    .subscribe(andonGroup => this.andonGroup = andonGroup);
  }

  // あんどん通知情報をクローズする
  public closeAndonNotice(): void {
    // this.http.get(this.AndonGroupUrl).toPromise();
    // this.andonNoticeService.closeAndonNotice({ andonNoticeID: 273, noticeAuthor: 'System' });
    // this.outputAndonNoticeID = new OutputAndonNoticeID;
    this.outputAndonNoticeID.andonNoticeID = this.AndonNoticeID;
    this.outputAndonNoticeID.noticeUpdater = this.UserID;
    this.andonNoticeService.errMessage = this.NameMst[this.LangId].apierror;
    this.andonNoticeService.closeAndonNotice(this.outputAndonNoticeID);
    console.log('closeAndonNotice() test');
  }
  // あんどん通知情報を削除する
  public deleteAndonNotice(): void {
    // this.http.get(this.AndonGroupUrl).toPromise();
    // this.andonNoticeService.closeAndonNotice({ andonNoticeID: 273, noticeAuthor: 'System' });
    // this.outputAndonNoticeID = new OutputAndonNoticeID;
    this.outputAndonNoticeID.andonNoticeID = this.AndonNoticeID;
    this.outputAndonNoticeID.noticeUpdater = this.UserID;
    this.andonNoticeService.errMessage = this.NameMst[this.LangId].apierror;
    this.andonNoticeService.deleteAndonNotice(this.outputAndonNoticeID);
    console.log('deleteAndonNotice() test');
  }
   // あんどん通知情報を登録する
   public createdAndonNotice(): void {
    //    this.http.get(this.AndonGroupUrl).toPromise();
    // this.andonNoticeService.createAndonNotice();
    this.andonNoticeNew.andonNoticeID = 0;
    this.andonNoticeNew.andonID = this.AndonID;
    this.andonNoticeNew.andonName = this.AndonName;
    // console.log(this.andonCauseCode.length);
    if ( this.andonCauseCode.length > 0 ) {
      this.andonNoticeNew.causeCode = this.andonCauseCode[this.CauseCodeIndex].causeCode;
      this.andonNoticeNew.content = this.andonCauseCode[this.CauseCodeIndex].content;
    } else {
      this.andonNoticeNew.causeCode = '';
      this.andonNoticeNew.content = '';
    }
    this.andonNoticeNew.andonColor = this.AndonColor;
    if (this.AttachementFile !== null) {
      this.andonNoticeNew.attachment = this.AttachementFile;
    } else {
      this.andonNoticeNew.attachment = '';
    }
    this.andonNoticeNew.noticeAuthor = this.UserID;
    this.andonNoticeNew.noticeUpdater = this.UserID;
    this.andonNoticeNew.lastModifyDate = new Date;
    this.andonNoticeNew.delayFlg = false;
    this.andonNoticeService.errMessage = this.NameMst[this.LangId].apierror;
    this.andonNoticeService.createAndonNotice( this.andonNoticeNew );
    console.log('createdonNotice() uploadFile()');
    this.uploadFile();
  }
  // あんどん通知情報を取得する
  public getAndonNotice( andonNoticeID ): void {
    //    this.http.get(this.AndonGroupUrl).toPromise();
    this.andonNoticeService.errMessage = this.NameMst[this.LangId].apierror;
    this.andonNoticeService.getAndonNotice( andonNoticeID )
      .subscribe(andonNotice => this.andonNoticeSel = andonNotice);
  }
  // あんどん通知リストを取得する
  public getAndonNoticeList(): void {
    //    this.http.get(this.AndonGroupUrl).toPromise();
    this.andonNoticeService.errMessage = this.NameMst[this.LangId].apierror;
    this.andonNoticeService.getAndonNoticeList( this.AndonID )
      .subscribe(andonNotice => this.andonNoticeList = andonNotice);
  }
  // あんどんランプ一覧を取得する
  public getAndonNoticeSum(): void {
    //    this.http.get(this.AndonGroupUrl).toPromise();
    this.andonNoticeService.errMessage = this.NameMst[this.LangId].apierror;
    if ( this.AndonGroupID === 0 ) {
        this.andonNoticeService.getAndonNoticeSum( { UserID: this.UserID } )
        .subscribe(andonNoticeSum => this.andonNoticeSum = andonNoticeSum);
    } else {
        this.andonNoticeService.getAndonNoticeSum( { AndonGroupID: this.AndonGroupID, UserID: this.UserID } )
        .subscribe(andonNoticeSum => this.andonNoticeSum = andonNoticeSum);
    }
  }

  // あんどん通知登録
  public registration(): void {

    // 初期化
    this.andonNoticeNew.title = '';
    this.andonNoticeNew.message = '';
    this.AndonColor = 'Info';

    // 理由コード取得
    //    this.http.get(this.AndonGroupUrl).toPromise();
    this.andonCauseCodeService.errMessage = this.NameMst[this.LangId].apierror;
    this.andonCauseCodeService.getCauseCode( this.AndonID )
        .subscribe(andonCauseCode => this.andonCauseCode = andonCauseCode);
  }

  // 画面更新
  // 表示内容リフレッシュ
  public refresh(): void {
    if ( this.Display === 1 ) {
      this.getAndonNoticeSum();
      console.log('refresh あんどんランプ' );
    } else if ( this.Display === 2 ) {
      this.getAndonNoticeList();
      console.log('refresh あんどん通知リスト' );
    } else if ( this.lastDialogAction === 3 ) {
      console.log('refresh あんどん通知' );
    }
  }

  // あんどん通知
  // 確認ダイアログ表示
  public openSnackbar( message ) {
    this._snackbar.open( message, 'OK');
  }

  // あんどん通知
  // 確認ダイアログ表示
  public openDialog() {
    // DialogContentComponent.continueMessage = '';
    const dialogRef = this._dialog.open(DialogContentComponent);
    dialogRef.afterClosed()
      .subscribe(result => {
        this.lastDialogResult = result;
        if ( result ) {
          if ( this.lastDialogAction === 4 ) {
            this.createdAndonNotice();
            console.log('新規登録' );
            this.Display = 2;
          } else if ( this.lastDialogAction === 3 ) {
            this.deleteAndonNotice();
            console.log('通知削除' );
            this.Display = 2;
          } else if ( this.lastDialogAction === 2 ) {
            this.closeAndonNotice();
            console.log('状態復帰' );
            this.Display = 2;
          }
        }
          console.log('onClickOkButton()' + this.lastDialogResult );
      }
    );
  }

  // あんどん通知登録
  // 添付ファイル取得処理
  // ng2-file-uploadを使わない
  public onchangefile__(list: any) {
    // ファイルが指定されていなければ
    if (list.length <= 0) { return; }

    // ［3］ファイルを取得
    const f = list[0];

    // ［4］ファイルをセット
    this.AttachementFile = this.AndonID + '-' + f.name;
    const formdata = new FormData();
    formdata.append('photo', f, this.AttachementFile );

    //  ［5］サーバーに送信
    console.log('Upload:' + environment.uploadUrl);
     this.http.post(environment.uploadUrl, formdata)
      .subscribe(
        data => { console.log(data); },
        error => { console.log(error); alert(this.NameMst[this.LangId].apierror); this.AttachementFile = ''; }
      );
  }

  // あんどん通知登録
  // 添付ファイル取得処理
  public onchangefile(list: any) {
    // ファイルが指定されていなければ
    if (list.length <= 0) { return; }
    this.SelectedFile = list[0];
    /*
    this.now = new Date();
    this.AttachementFile = 'IMG_' + this.now.getFullYear() + this.now.getMonth() + this.now.getDate()
     + this.now.getHours() + this.now.getMinutes() + this.now.getSeconds() + '.JPG';
    */
    this.AttachementFile = this.AndonID + '-' + this.getCurrentTime() + '-' + this.SelectedFile.name;
    console.log('ファイル選択(' + this.AttachementFile  + ')' );
  }

  // あんどん通知登録
  // 添付ファイル アップロード処理
  public uploadFile() {
    const formdata = new FormData();
    formdata.append('photo', this.SelectedFile, this.AttachementFile );

    // サーバーに送信
    console.log('Upload:' + environment.uploadUrl);
     this.http.post(environment.uploadUrl, formdata)
      .subscribe(
        data => { console.log(data); },
        error => { console.log(error); alert(this.NameMst[this.LangId].apierror); this.AttachementFile = ''; }
      );
    // console.log( this.uploader.queue[0].file.name + ',' +
    // this.uploader.queue[0].file.size + ',' + this.uploader.queue[0].file.type );
    // ng2-file-uploaderの場合
    // this.uploader.uploadAll();
    /* Azureの場合
    if (this.currentFile !== null) {
      const baseUrl = this.blob.generateBlobUrl(Config, this.AttachementFile);
      this.config = {
        baseUrl: baseUrl,
        sasToken: Config.sas,
        blockSize: 1024 * 64, // OPTIONAL, default value is 1024 * 32
        file: this.currentFile,
        complete: () => {
          console.log('Transfer completed !');
        },
        error: () => {
          console.log('Error !');
        },
        progress: (percent) => {
          this.percent = percent;
        }
      };
      this.blob.upload(this.config);
    }
    */
  }

  // 現在時刻取得（yyyymmddhhmmss）
  getCurrentTime() {
    const now = new Date();
    const res = now.getFullYear() + this.padZero(now.getMonth() + 1)
     + this.padZero(now.getDate()) + this.padZero(now.getHours())
     + this.padZero(now.getMinutes()) + this.padZero(now.getSeconds());
    return res;
  }
   // 先頭ゼロ付加
  padZero(num) {
    let result;
    if (num < 10) {
      result = '0' + num;
    } else {
      result = '' + num;
    }
    return result;
  }

}

@Component({
  template: `
    <!--h1 matDialogTitle>続行しますか？</h1-->
    <!--div matDialogContent>
      <mat-form-field>
        <label>{{this.DialogMassage}}</label>
      </mat-form-field>
    </div-->
    <h1 matDialogTitle>{{continueMessage}}</h1>
    <div matDialogActions>
      <button mat-raised-button [matDialogClose]="1" color="primary">OK</button>
      <button mat-raised-button [matDialogClose]="0">Cancel</button>
    </div>
  `,
})
export class DialogContentComponent {
  continueMessage = 'Do you want to continue?';
  constructor( @Optional() public dialogRef: MatDialogRef<DialogContentComponent>) { }
}




